const isMetaSource =
  new URLSearchParams(window.location.search).get('utm_source') === 'meta'

export const getIsMetaSource = (): boolean => isMetaSource
